"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const react_hanger_1 = require("react-hanger");
const react_if_1 = require("react-if");
const hooks_1 = require("../../../../hooks");
exports.ChangePassword = ({ userId }) => {
    const { currentUser } = hooks_1.useOsmosysContext();
    const [isOpen, toggle] = react_use_1.useToggle(false);
    // Inputs
    const currentPassword = react_hanger_1.useInput('');
    const newPassword = react_hanger_1.useInput('');
    // Mutation
    const { mutate, mutationResult } = hooks_1.useChangePassword(currentUser.id, currentPassword.value, newPassword.value, {
        onCompleted: () => {
            toggle(false);
        },
    });
    if (!currentUser || currentUser.id !== userId) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    // When closed:
    if (!isOpen) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reactstrap_1.Button, { size: "sm", type: "button", onClick: () => {
                    toggle(true);
                } }, "Change password"),
            react_1.default.createElement(react_if_1.When, { condition: !!mutationResult.data },
                react_1.default.createElement("p", null,
                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "success" }),
                    " Password changed!"))));
    }
    // When opened:
    return (react_1.default.createElement(reactstrap_1.Card, { body: true },
        react_1.default.createElement("h4", null, "Change password"),
        react_1.default.createElement(reactstrap_1.FormGroup, null,
            react_1.default.createElement(reactstrap_1.Label, null, "Current password"),
            react_1.default.createElement(reactstrap_1.Input, Object.assign({ type: "password" }, currentPassword.eventBind))),
        react_1.default.createElement(reactstrap_1.FormGroup, null,
            react_1.default.createElement(reactstrap_1.Label, null, "New password"),
            react_1.default.createElement(reactstrap_1.Input, Object.assign({ type: "password" }, newPassword.eventBind))),
        react_1.default.createElement("div", { className: "mb-2" },
            react_1.default.createElement(react_2.OsmosysButton, { osysName: "NewPassword", size: "sm", type: "button", mutate: mutate, mutationResult: mutationResult, color: "success", className: "mr-2", renderApolloError: true }, "Change password")),
        react_1.default.createElement("div", null,
            react_1.default.createElement(reactstrap_1.Button, { size: "sm", type: "button", onClick: () => {
                    if (currentPassword.hasValue || newPassword.hasValue) {
                        const confirmed = window.confirm('Are you sure you want to cancel?');
                        if (!confirmed) {
                            return;
                        }
                    }
                    toggle(false);
                } }, "Cancel"))));
};
//# sourceMappingURL=ChangePassword.js.map